import React from 'react';
import { B, D, Arr, Lbl } from '../shared/SvgHelpers';

export default function DiagramBenutzer() {
  return (
    <div className="space-y-3" data-testid="diagram-benutzer">
      <h4 className="text-sm font-bold text-purple-700">6. Benutzer-Lebenszyklus &amp; Authentifizierung</h4>
      <svg viewBox="0 0 780 290" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        {/* Registration */}
        <B x={10} y={18} w={85} h={42} label="Registrierung" color="#2563eb" />
        <Arr x1={95} y1={39} x2={130} y2={39} />
        <B x={130} y={18} w={100} h={42} label={"Warten auf\nFreigabe"} color="#d97706" sub="approved=false" />
        <Arr x1={230} y1={39} x2={265} y2={39} />
        <D x={303} y={39} s={28} label={"Admin\ngenehmigt?"} color="#d97706" />
        <Arr x1={331} y1={39} x2={370} y2={39} />
        <Lbl x={337} y={30} text="Ja" color="#16a34a" />
        <B x={370} y={18} w={95} h={42} label="Aktiv" color="#16a34a" sub="approved=true" />

        <Arr x1={303} y1={67} x2={303} y2={92} />
        <Lbl x={310} y={84} text="Nein" color="#dc2626" />
        <B x={263} y={92} w={80} h={28} label="Abgelehnt" color="#dc2626" />

        {/* Login-Prozess */}
        <Arr x1={465} y1={39} x2={495} y2={39} />
        <B x={495} y={18} w={75} h={42} label="Login" color="#4f46e5" sub="User+Pass" />
        <Arr x1={570} y1={39} x2={605} y2={39} />
        <D x={638} y={39} s={24} label={"2FA\naktiv?"} color="#7c3aed" />
        <Arr x1={662} y1={39} x2={695} y2={39} />
        <Lbl x={668} y={30} text="Ja" />
        <B x={695} y={15} w={75} h={50} label={"TOTP Code\n+ 10 Backup-\nCodes"} color="#7c3aed" sub="hashed" />
        <Arr x1={638} y1={63} x2={638} y2={85} />
        <Lbl x={644} y={82} text="Nein" color="#64748b" />
        <B x={605} y={85} w={70} h={28} label="JWT Token" color="#16a34a" sub="15min" />
        <Arr x1={732} y1={65} x2={675} y2={88} />

        {/* Brute-Force Progressive Table */}
        <rect x={15} y={130} width={350} height={110} rx={6} fill="#fee2e2" stroke="#dc2626" strokeWidth={1.5} />
        <text x={190} y={148} textAnchor="middle" fontSize="10" fontWeight="700" fill="#991b1b">
          Progressive Brute-Force-Sperre (4-stufig)
        </text>
        <text x={30} y={167} fontSize="9" fontWeight="700" fill="#334155">Fehlversuche</text>
        <text x={180} y={167} fontSize="9" fontWeight="700" fill="#334155">Sperrzeit</text>
        <line x1={25} y1={172} x2={355} y2={172} stroke="#dc2626" strokeWidth={0.5} />
        {[
          { f: '≥ 5', l: '5 Minuten', y: 185, c: '#eab308' },
          { f: '≥ 10', l: '15 Minuten', y: 200, c: '#f97316' },
          { f: '≥ 20', l: '1 Stunde', y: 215, c: '#dc2626' },
          { f: '≥ 30', l: '24 Stunden', y: 230, c: '#7f1d1d' },
        ].map((r, i) => (
          <g key={i}>
            <rect x={25} y={r.y - 10} width={10} height={10} fill={r.c} />
            <text x={45} y={r.y - 1} fontSize="9" fill="#334155" fontWeight="600">{r.f}</text>
            <text x={180} y={r.y - 1} fontSize="9" fill="#334155">{r.l}</text>
          </g>
        ))}

        {/* Admin-Aktionen */}
        <B x={385} y={135} w={95} h={32} label="Deaktivieren" color="#64748b" sub="Admin" />
        <Arr x1={480} y1={151} x2={515} y2={151} />
        <B x={515} y={135} w={95} h={32} label="Reaktivieren" color="#16a34a" sub="Admin" />

        {/* Password-Reset */}
        <B x={385} y={175} w={225} h={32} label={"Passwort-Reset per E-Mail-Token (30 Min gültig)"} color="#0891b2" />

        {/* Login History */}
        <B x={385} y={215} w={225} h={25} label="Login-Historie: letzte 50 Logins (IP/UA/Zeit)" color="#4f46e5" />

        {/* Sessions */}
        <rect x={625} y={135} width={150} height={105} rx={6} fill="#f0fdf4" stroke="#16a34a" strokeWidth={1.5} />
        <text x={700} y={151} textAnchor="middle" fontSize="10" fontWeight="700" fill="#14532d">Session-Management</text>
        <text x={635} y={167} fontSize="9" fill="#334155">Access: 15 Min</text>
        <text x={635} y={181} fontSize="9" fill="#334155">Refresh: 7 Tage</text>
        <text x={635} y={195} fontSize="9" fill="#334155">HttpOnly Cookie</text>
        <text x={635} y={209} fontSize="9" fill="#334155">SameSite CSRF</text>
        <text x={635} y={223} fontSize="9" fill="#334155">Blacklist bei Logout</text>
        <text x={635} y={237} fontSize="9" fill="#334155">Auto-Rotation</text>

        {/* Hinweis */}
        <text x={15} y={265} fontSize="8" fill="#64748b" fontStyle="italic">
          Hinweis: Status="active" + approved=false → Login wird mit 403 abgelehnt bis Admin-Freigabe (login.py:128-131)
        </text>
        <text x={15} y={278} fontSize="8" fill="#64748b" fontStyle="italic">
          Quelle: backend/domains/auth/brute_force.py (AUTH_LOCKOUT_THRESHOLDS) · two_factor.py · login.py
        </text>
      </svg>
    </div>
  );
}
